/**
 * @generated SignedSource<<50b2560a3e6c704b2b2bc56e8205c9d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChannelOrdering = "CREATED_ASC" | "CREATED_DESC" | "NAME_ASC" | "NAME_DESC" | "ORDER_ASC" | "ORDER_DESC";
export type LibraryPanelQuery$variables = {
  orderBy?: ChannelOrdering | null;
};
export type LibraryPanelQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToMyTeamPseudoChannel: boolean;
      };
    };
    readonly channels: ReadonlyArray<{
      readonly id: string;
      readonly isFavorites: boolean;
      readonly isMember: boolean;
      readonly isMyMeetings: boolean;
      readonly isPersonal: boolean;
      readonly isPrivate: boolean;
      readonly isWorkspaceWide: boolean;
      readonly lastPostedAt: string | null;
      readonly name: string;
      readonly viewerLastSeenAt: string | null;
    }>;
    readonly user: {
      readonly isManager: boolean;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AddToLibraryMenu_viewer" | "LibraryHooksUseOpenChannelsModal_viewer" | "LibraryPanelChannelLink_viewer" | "RecordWithUrlButton_viewer">;
  };
};
export type LibraryPanelQuery = {
  response: LibraryPanelQuery$data;
  variables: LibraryPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isManager",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "excludePersonal",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "memberOnly",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "orderBy",
      "variableName": "orderBy"
    }
  ],
  "concreteType": "Channel",
  "kind": "LinkedField",
  "name": "channels",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWorkspaceWide",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPersonal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMyMeetings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavorites",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerLastSeenAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPostedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": "hasAccessToMyTeamPseudoChannel",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "my_team_pseudo_channel"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"my_team_pseudo_channel\")"
},
v6 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "channels"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "meeting_recorder"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostEnabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostUnit",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostAvgSalary",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingAttendeesEnabled",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxRecommendedAttendees",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursWarningEnabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursLimit",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDaysEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDay",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeEnabled",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeNumHours",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finiteRecurringMeetingsEnabled",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsEnabled",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsBehaviour",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingEnabled",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingGuidelinesUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v25 = [
  (v2/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeZone",
  "kind": "LinkedField",
  "name": "timezone",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecordWithUrlButton_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LibraryHooksUseOpenChannelsModal_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LibraryPanelChannelLink_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AddToLibraryMenu_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LibraryPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": "canCreateChannels",
                    "args": (v6/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"channels\")"
                  },
                  {
                    "alias": "hasCopilotAddon",
                    "args": (v7/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  },
                  {
                    "alias": "canUseChannels",
                    "args": (v6/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"channels\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSubscriptionActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionState",
                    "storageKey": null
                  },
                  {
                    "alias": "hasAccessToMeetingGuidelines",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_guidelines"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_guidelines\")"
                  },
                  {
                    "alias": "hasAccessToMeetingCost",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_cost"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_cost\")"
                  },
                  {
                    "alias": "hasAccessToMeetingRecorderFeature",
                    "args": (v7/*: any*/),
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowBotlessRecording",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountUploadCredits",
                "kind": "LinkedField",
                "name": "uploadCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedUploadCredits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedCreditsUsedCurrentCycle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPersonalType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailDomainList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "primaryAdmin",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountRecordingCredits",
                "kind": "LinkedField",
                "name": "recordingCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedAiMeetingCredits",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExtensionSettings",
                "kind": "LinkedField",
                "name": "extensionSettings",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCostEnforceWorkspaceSettings",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingMeetingRecordingCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserRecordingAutoPublishSettings",
            "kind": "LinkedField",
            "name": "autoPublishRecordingSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Channel",
                "kind": "LinkedField",
                "name": "externalRecordingsChannel",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Channel",
                "kind": "LinkedField",
                "name": "internalRecordingsChannel",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToScheduledMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAutoRecordSettings",
            "kind": "LinkedField",
            "name": "autoRecordSettings",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingOwnershipFilter",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarConnection",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourcePrimary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSyncDatetime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hadErrorOnSync",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultConferenceProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasMeetingWriteScope",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserSettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimezonePreferences",
                "kind": "LinkedField",
                "name": "timezonePreferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTimezone",
                    "kind": "LinkedField",
                    "name": "preferredTimezone",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTimezone",
                    "kind": "LinkedField",
                    "name": "extraTimezones",
                    "plural": true,
                    "selections": [
                      (v27/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingGuidelines",
            "kind": "LinkedField",
            "name": "meetingGuidelines",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f95d3aabe5fca4ed38f4df4916bdbe6",
    "id": null,
    "metadata": {},
    "name": "LibraryPanelQuery",
    "operationKind": "query",
    "text": "query LibraryPanelQuery(\n  $orderBy: ChannelOrdering\n) {\n  viewer {\n    user {\n      isManager\n      id\n    }\n    channels(memberOnly: true, excludePersonal: true, orderBy: $orderBy) {\n      id\n      name\n      isWorkspaceWide\n      isPersonal\n      isMember\n      isPrivate\n      isMyMeetings\n      isFavorites\n      viewerLastSeenAt\n      lastPostedAt\n    }\n    account {\n      billingAccount {\n        hasAccessToMyTeamPseudoChannel: hasAccessToFeature(feature: my_team_pseudo_channel)\n        id\n      }\n      id\n    }\n    ...RecordWithUrlButton_viewer\n    ...LibraryHooksUseOpenChannelsModal_viewer\n    ...LibraryPanelChannelLink_viewer\n    ...AddToLibraryMenu_viewer\n    id\n  }\n}\n\nfragment AddToLibraryMenu_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  account {\n    allowBotlessRecording\n    billingAccount {\n      subscriptionBillingCycleAnchor\n      id\n    }\n    uploadCredits {\n      includedUploadCredits\n      includedCreditsUsedCurrentCycle\n    }\n    id\n  }\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  ...EventFormModal_viewer\n  ...BillingIdentityFeaturesPaywall_viewer\n  ...UploadMenuItem_viewer\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment EventFormModal_viewer on Viewer {\n  hasAccessToScheduledMeetingRecordings\n  ...EventForm_viewer\n  ...usePreferredTimezone_viewer\n  ...WeekPreview_viewer\n  remainingMeetingRecordingCredits\n  account {\n    extensionSettings {\n      meetingCostEnabled\n      meetingCostEnforceWorkspaceSettings\n      meetingCostUnit\n      meetingCostAvgSalary\n      meetingAttendeesEnabled\n      maxRecommendedAttendees\n      attendeeWeeklyMeetingHoursWarningEnabled\n      attendeeWeeklyMeetingHoursLimit\n      noMeetingDaysEnabled\n      noMeetingDay\n      shortNoticeEnabled\n      shortNoticeNumHours\n      finiteRecurringMeetingsEnabled\n      breaksBetweenMeetingsEnabled\n      breaksBetweenMeetingsBehaviour\n      promptWhenSavingEnabled\n      promptWhenSavingGuidelinesUrl\n      id\n    }\n    billingAccount {\n      hasAccessToMeetingGuidelines: hasAccessToFeature(feature: meeting_guidelines)\n      hasAccessToMeetingCost: hasAccessToFeature(feature: meeting_cost)\n      hasAccessToMeetingRecorderFeature: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n  meetingGuidelines {\n    meetingCostEnabled\n    meetingCostUnit\n    meetingCostAvgSalary\n    meetingAttendeesEnabled\n    maxRecommendedAttendees\n    attendeeWeeklyMeetingHoursWarningEnabled\n    attendeeWeeklyMeetingHoursLimit\n    noMeetingDaysEnabled\n    noMeetingDay\n    shortNoticeEnabled\n    shortNoticeNumHours\n    finiteRecurringMeetingsEnabled\n    breaksBetweenMeetingsEnabled\n    breaksBetweenMeetingsBehaviour\n    promptWhenSavingEnabled\n    promptWhenSavingGuidelinesUrl\n  }\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        timezone {\n          name\n        }\n        userLabel\n      }\n      extraTimezones {\n        timezone {\n          name\n        }\n        userLabel\n      }\n    }\n  }\n}\n\nfragment EventForm_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  account {\n    name\n    id\n  }\n  user {\n    id\n    firstName\n  }\n  autoRecordSettings {\n    enabled\n    meetingOwnershipFilter\n    id\n  }\n  calendars {\n    edges {\n      node {\n        id\n        source\n        sourcePrimary\n        syncEnabled\n        name\n        color\n        lastSyncDatetime\n        hadErrorOnSync\n      }\n    }\n  }\n  ...useConferencingOptions_viewer\n  ...useParticipantsOptions_viewer\n  ...usePreferredTimezone_viewer\n  ...RecordingRowOutOfCreditsWarning_viewer\n}\n\nfragment LibraryHooksUseLeaveChannel_viewer on Viewer {\n  autoPublishRecordingSettings {\n    id\n    enabled\n    externalRecordingsChannel {\n      id\n    }\n    internalRecordingsChannel {\n      id\n    }\n  }\n}\n\nfragment LibraryHooksUseOpenChannelsModal_viewer on Viewer {\n  account {\n    billingAccount {\n      canCreateChannels: hasAccessToFeature(feature: channels)\n      id\n    }\n    id\n  }\n}\n\nfragment LibraryPanelChannelLink_viewer on Viewer {\n  ...LibraryHooksUseLeaveChannel_viewer\n  account {\n    billingAccount {\n      canUseChannels: hasAccessToFeature(feature: channels)\n      id\n    }\n    id\n  }\n}\n\nfragment RecordWithUrlButton_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  ...LibraryHooksUseOpenChannelsModal_viewer\n  ...featureFlag_useCopilotPaywallsOn_viewer\n}\n\nfragment RecordingRowOutOfCreditsWarning_viewer on Viewer {\n  hasAdminAccess\n  account {\n    primaryAdmin {\n      fullName\n      id\n    }\n    recordingCredits {\n      includedAiMeetingCredits\n      id\n    }\n    billingAccount {\n      isSubscriptionActive\n      subscriptionState\n      subscriptionBillingCycleAnchor\n      id\n    }\n    id\n  }\n}\n\nfragment UploadMenuItem_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  account {\n    billingAccount {\n      subscriptionBillingCycleAnchor\n      id\n    }\n    uploadCredits {\n      includedUploadCredits\n      includedCreditsUsedCurrentCycle\n    }\n    id\n  }\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  ...BillingIdentityFeaturesPaywall_viewer\n}\n\nfragment WeekPreview_viewer on Viewer {\n  ...usePreferredTimezone_viewer\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        userLabel\n        timezone {\n          name\n        }\n      }\n      extraTimezones {\n        userLabel\n        timezone {\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment featureFlag_useCopilotPaywallsOn_viewer on Viewer {\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n}\n\nfragment useConferencingOptions_viewer on Viewer {\n  id\n  defaultConferenceProvider\n  user {\n    id\n  }\n  integrations {\n    zoom {\n      id\n      hasMeetingWriteScope\n    }\n  }\n  calendars {\n    edges {\n      node {\n        id\n        source\n      }\n    }\n  }\n}\n\nfragment useParticipantsOptions_viewer on Viewer {\n  account {\n    isPersonalType\n    emailDomainList\n    id\n  }\n}\n\nfragment usePreferredTimezone_viewer on Viewer {\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        timezone {\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b5539ea95163914793fc8a778db509a";

export default node;
